import React from 'react';

import { Tooltip } from 'antd';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import MiniLoading from '@components/Gui/MiniLoading';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables.js';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelAvailabilityIcon = ({ modelId, isFetched, isBusy, size, inEvent }) => {
    const {
        actions: { isFetchingAvailability },
    } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();

    return (
        <div>
            {isFetched ? (
                <div className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                    {isFetchingAvailability ? (
                        <MiniLoading />
                    ) : inEvent === 2 ? (
                        <NwIcon
                            size={size}
                            icon={byPrefixAndName.fass['circle-check']}
                            style={{ color: StyleVariables.PrimaryColor }}
                        />
                    ) : isBusy ? (
                        <Tooltip title="Click to view model events">
                            <NwIcon
                                size={size}
                                icon={byPrefixAndName.fasl['calendar-exclamation']}
                                style={{ color: StyleVariables.DangerColor }}
                                pointer
                                onClick={(e) => {
                                    e.stopPropagation();
                                    cs_dispatch({
                                        type: 'OpenModelAvailabilityDrawer',
                                        modelId: modelId,
                                    });
                                }}
                            />
                        </Tooltip>
                    ) : (
                        <NwIcon
                            size={size}
                            icon={byPrefixAndName.fasl['calendar-check']}
                            style={{ color: StyleVariables.SuccessColor }}
                        />
                    )}
                </div>
            ) : (
                <p>&nbsp;</p>
            )}
        </div>
    );
};

export default ModelAvailabilityIcon;
